var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M21 1a1 1 0 0 1 1 1v20a1 1 0 1 1-2 0V2a1 1 0 0 1 1-1zM10.707 6.293l5 5a1 1 0 0 1 0 1.414l-5 5a1 1 0 0 1-1.414-1.414L12.586 13H5a1 1 0 1 1 0-2h7.586L9.293 7.707a1 1 0 0 1 1.414-1.414z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }